import { JSX } from 'react';
import classNames from 'classnames';
import { ModalClose } from '@bg-components/Modal/ModalClose';
import { ModalHeader } from '@bg-components/Modal/ModalHeader';
import classes from './PagesModalHeader.module.scss';

interface IProps {
    title: string | JSX.Element;
    onClose(): void;
    icon?: IIconComponent;
    className?: string;
    border?: boolean;
}

export const PagesModalHeader = (props: IProps): JSX.Element => {
    const Icon = props.icon;
    return (
        <ModalHeader className={classNames(props.className, { [classes.border]: props.border })}>
            <div className={classes.titleContainer}>
                {props.icon && <Icon className={classes.icon} />}
                <span>{props.title}</span>
            </div>
            <ModalClose className={classes.close} onClose={props.onClose} />
        </ModalHeader>
    );
};
